module.exports = __webpack_public_path__ + "static/media/Inland waterways.a6066cc5.jpg";